import {IAddress} from 'src/app/interfaces/general/profile-definitions/address.interface';

export class GetAddresses {
    public static readonly type = '[Addresses] Get addresses';
}

export class GetAddress {
    public static readonly type = '[Addresses] Get address';
    constructor(public identifier: string) {}
}

export class CreateAddress {
    public static readonly type = '[Addresses] Create address';
    constructor(public address: Partial<IAddress>) {}
}

export class UpdateAddress {
    public static readonly type = '[Addresses] Update address';
    constructor(public identifier: string, public address: Partial<IAddress>) {}
}

export class DeleteAddress {
    public static readonly type = '[Addresses] Delete address';
    constructor(public identifier: string) {}
}